<template>
<v-flex :class="classes" >
    <v-menu
        v-model="menu"
        :close-on-content-click="false"
        lazy
        transition="scale-transition"
        full-width
        min-width="290px"
      >
        <v-text-field
          slot="activator"
          v-model="formatted"
          readonly
          :label="label"
          :required="required"
          :hint="hint"
          :error-messages="errorMessages"
        ></v-text-field>
        <v-date-picker
          v-model="fieldValue"
          first-day-of-week="0"
          locale="fr-fr"
          />

      </v-menu>
</v-flex>
</template>

<script>
import moment from 'moment'
import _ from 'lodash'
import FieldMixin from '@/components/form/FieldMixin'

export default {
  mixins: [FieldMixin],
  computed: {
    classes () { return this.field.classes || 'xs6' },
    formatted () {
      return _.isString(this.fieldValue) ? moment(this.fieldValue).format('DD/MM/YYYY') : this.fieldValue
    },
  },
}
</script>
